/** Shared Validation panel helpers (client + server paging). */

export const VALIDATION_STATUS_ORDER = ['Yes', 'No', 'NA', 'Error'];

export const VALIDATION_PAGE_SIZES = [10, 50, 100, 500];
export const VALIDATION_DEFAULT_PAGE_SIZE = 50;

export function normalizeValidationStatus(value) {
  const text = String(value || '').trim();
  const lower = text.toLowerCase();
  if (['yes', 'true', '1', 'pass', 'passed', 'match'].includes(lower)) return 'Yes';
  if (['no', 'false', '0', 'fail', 'failed', 'not', 'mismatch'].includes(lower)) return 'No';
  if (['na', 'n/a', 'n.a.', 'not applicable'].includes(lower)) return 'NA';
  if (['error', 'err', '-1'].includes(lower) || lower.includes('error')) return 'Error';
  return text || 'NA';
}

export function validationStatusClass(status) {
  if (status === 'Yes') return 'bg-emerald-50 text-emerald-700';
  if (status === 'No') return 'bg-rose-50 text-rose-700';
  if (status === 'Error') return 'bg-amber-50 text-amber-900';
  return 'bg-slate-100 text-slate-700';
}

export function countValidationStatuses(items) {
  const counts = { Yes: 0, No: 0, NA: 0, Error: 0 };
  for (const item of items || []) {
    const status = item.status || normalizeValidationStatus(item.resultStatus);
    if (counts[status] !== undefined) counts[status] += 1;
  }
  return counts;
}

export function splitValidationGroup(name) {
  const raw = String(name || 'Validation').trim() || 'Validation';
  const index = raw.indexOf(' · ');
  if (index === -1) {
    if (/^validation\b/i.test(raw)) return { tab: raw, group: 'General' };
    return { tab: 'Validation', group: raw };
  }
  return {
    tab: raw.slice(0, index).trim() || 'Validation',
    group: raw.slice(index + 3).trim() || 'General',
  };
}

export function validationTabRank(tab) {
  const lower = String(tab || '').toLowerCase();
  if (lower.includes('documentation')) return 0;
  if (lower.includes('credit')) return 1;
  if (lower.includes('loan tape')) return 3;
  return 2;
}
